import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import { CLIENTS_ENDPOINT } from "../../consts";
import ClientForm from "../../components/clientForm/ClientForm.component";
import { useHasPermission } from "../../contexts/auth";

export const ClientsActions = () => {
  const { t } = useTranslation();
  const [addClientOpened, setAddClientOpened] = useState<boolean>(false);
  const canAddClient = useHasPermission("settlement.add_client");

  const actions: Action[] = [{
    id: "add-new-client",
    icon: <AddIcon />,
    label: t("Add new client"),
    onClick: () => { setAddClientOpened(true) },
    disabled: !canAddClient
  }];

  const handleClientAdded = () => {
    setAddClientOpened(false);
    window.dispatchEvent(new Event("clientAdded"));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addClientOpened}
        setOpened={setAddClientOpened}
        title={t("Add new client")}
        content={
          <ClientForm
            url={CLIENTS_ENDPOINT}
            onSuccess={handleClientAdded}
          />
        }
      />
    </>
  );
};
